const getWorkspaceUuid = (workspace) => workspace?.uuid || workspace?.workspace_uuid

const hasMatchingActiveWorkspace = (project, activeWorkspace) => {
  const projectWorkspaceUuid = project?.workspace_uuid || project?.workspaceUuid
  return Boolean(
    projectWorkspaceUuid &&
    activeWorkspace?.type === 'team' &&
    projectWorkspaceUuid === getWorkspaceUuid(activeWorkspace)
  )
}

export const hasProjectWorkspaceEntitlement = (project, activeWorkspace) => {
  if (!project) return false
  if (project.workspace_type === 'personal') return false
  if (project.is_workspace_member === true && project.workspace_type === 'team') return true
  if (project.is_workspace_member === true && project.workspace_uuid) return true
  if (hasMatchingActiveWorkspace(project, activeWorkspace)) return true
  return false
}

export const hasWorkspaceFeatureEntitlement = ({
  activeProject,
  activeWorkspace,
  project,
  projectInfo
} = {}) => {
  const projectContexts = [
    activeProject,
    project,
    projectInfo
  ].filter(Boolean)
  if (projectContexts.length) {
    const hasEntitlement = projectContexts.some(item => hasProjectWorkspaceEntitlement(item, activeWorkspace))
    return hasEntitlement
  }
  return activeWorkspace?.type === 'team'
}

export const hasEnabledFeature = (user, featureName) => {
  if (!featureName) return true
  if (user?.subscriptionPlan && user.subscriptionPlan !== 'free') return true
  const feature = (user?.features || []).find(item => item.name === featureName)
  // if feature is not found, assume it's enabled for free users (default to true)
  if (!feature) {
    return true
  }
  return feature?.enabled === true
}

export const hasFeatureAccess = ({
  activeProject,
  activeWorkspace,
  featureName,
  project,
  projectInfo,
  user
} = {}) => {
  if (hasProFeatureEntitlement({
    activeProject,
    activeWorkspace,
    project,
    projectInfo,
    user
  })) return true
  return hasEnabledFeature(user, featureName)
}

export const getEffectiveSubscriptionPlan = ({
  activeProject,
  activeWorkspace,
  project,
  projectInfo,
  user
} = {}) => {
  if (hasWorkspaceFeatureEntitlement({
    activeProject,
    activeWorkspace,
    project,
    projectInfo
  })) {
    return 'pro'
  }
  return user?.subscriptionPlan || 'free'
}

export const hasProFeatureEntitlement = ({
  activeProject,
  activeWorkspace,
  project,
  projectInfo,
  user
} = {}) => {
  return getEffectiveSubscriptionPlan({
    activeProject,
    activeWorkspace,
    project,
    projectInfo,
    user
  }) === 'pro'
}

export const isSharedProjectRoute = (pathname = '') => {
  return pathname.split('/').filter(Boolean)[0] === 'shared_project'
}

export const shouldUseSharedProjectRoutes = ({
  pathname,
  project
} = {}) => {
  if (isSharedProjectRoute(pathname)) return true
  if (project?.is_owner === true && project?.is_shared === true) return true
  if (hasProjectWorkspaceEntitlement(project)) return false
  return Boolean(project?.shared_with_user_uuid)
}

export const buildProjectScopedRoute = ({
  basePath,
  projectUuid,
  scriptUuid
}) => {
  const normalizedBasePath = basePath.endsWith('/') ? basePath.slice(0, -1) : basePath
  if (projectUuid) return `${normalizedBasePath}/${projectUuid}/${scriptUuid}`
  return `${normalizedBasePath}/${scriptUuid}`
}
